import { PositionSetConfig } from "../../components";

export const setPlayer1: PositionSetConfig = {
  label: "Player 1",
  fieldSize: "HALF",
  positions: [
    { label: "1", playerIdNumber: 1, possession: true, pos: { x: 5, y: 30 } },
    { label: "2", playerIdNumber: 2, pos: { x: 15, y: 30 } },
    { label: "3", playerIdNumber: 3, pos: { x: 25, y: 30 } },
    { label: "4", playerIdNumber: 4, pos: { x: 35, y: 30 } },
    { label: "5", playerIdNumber: 5, pos: { x: 45, y: 30 } },
  ],
};

export const setPlayer2: PositionSetConfig = {
  label: "Player 2",
  fieldSize: "HALF",
  positions: [
    { label: "1", playerIdNumber: 1, pos: { x: 5, y: 30 } },
    { label: "2", playerIdNumber: 2, possession: true, pos: { x: 15, y: 30 } },
    { label: "3", playerIdNumber: 3, pos: { x: 25, y: 30 } },
    { label: "4", playerIdNumber: 4, pos: { x: 35, y: 30 } },
    { label: "5", playerIdNumber: 5, pos: { x: 45, y: 30 } },
  ],
};

export const setPlayer3: PositionSetConfig = {
  label: "Player 3",
  fieldSize: "HALF",
  positions: [
    { label: "1", playerIdNumber: 1, pos: { x: 5, y: 30 } },
    { label: "2", playerIdNumber: 2, pos: { x: 15, y: 30 } },
    { label: "3", playerIdNumber: 3, possession: true, pos: { x: 25, y: 30 } },
    { label: "4", playerIdNumber: 4, pos: { x: 35, y: 30 } },
    { label: "5", playerIdNumber: 5, pos: { x: 45, y: 30 } },
  ],
};

export const setPlayer4: PositionSetConfig = {
  label: "Player 4",
  fieldSize: "HALF",
  positions: [
    { label: "1", playerIdNumber: 1, pos: { x: 5, y: 30 } },
    { label: "2", playerIdNumber: 2, pos: { x: 15, y: 30 } },
    { label: "3", playerIdNumber: 3, pos: { x: 25, y: 30 } },
    { label: "4", playerIdNumber: 4, possession: true, pos: { x: 35, y: 30 } },
    { label: "5", playerIdNumber: 5, pos: { x: 45, y: 30 } },
  ],
};

export const setPlayer5: PositionSetConfig = {
  label: "Player 5",
  fieldSize: "HALF",
  positions: [
    { label: "1", playerIdNumber: 1, pos: { x: 5, y: 30 } },
    { label: "2", playerIdNumber: 2, pos: { x: 15, y: 30 } },
    { label: "3", playerIdNumber: 3, pos: { x: 25, y: 30 } },
    { label: "4", playerIdNumber: 4, pos: { x: 35, y: 30 } },
    { label: "5", playerIdNumber: 5, possession: true, pos: { x: 45, y: 30 } },
  ],
};

export const basketballSets: PositionSetConfig[] = [setPlayer1, setPlayer2, setPlayer3, setPlayer4, setPlayer5];
